module.exports = __webpack_public_path__ + "static/SLFCspread-6-75f853ee48589d22c4c92a2159b93ca5.jpg";